import { getRequest } from '@/core';
import { orders } from '@/requests';

export default async function getOrderByIdRequest(id) {
	let url = orders.getByIdPath(id);
	let response = await getRequest(url);
	return response;
}
